export type ApiError = {
  response?: { status?: number; data?: { detail?: unknown } };
};

// Cloudflare and other reverse-proxy errors that indicate the origin is
// unreachable or timed out — not a data/logic error the user can act on.
const GATEWAY_STATUSES = new Set([502, 503, 504, 522, 523, 524, 525, 530]);

export function getApiErrorMessage(error: unknown, fallback: string): string {
  const apiError = error as ApiError;

  const status = apiError?.response?.status;
  if (status && GATEWAY_STATUSES.has(status)) {
    return "Temporarily unavailable — the data source may be waking up. Please try again in a moment.";
  }

  const detail = apiError?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item === "object" && "msg" in item) {
          return String((item as { msg: unknown }).msg);
        }
        return "";
      })
      .filter(Boolean);
    if (messages.length > 0) return messages.join(". ");
  }
  if (detail && typeof detail === "object") {
    if ("message" in detail) return String((detail as { message: unknown }).message);
    if ("msg" in detail) return String((detail as { msg: unknown }).msg);
  }
  return fallback;
}
